import { LocationType, RentCalculationTypes } from "./Enums"
import { Zip } from "./index"
import { LocationRentAdjustment } from "./location-rent-adjustment";

export class Location {
    ID: string;
    IS_PRIMARY: boolean;
    NAME: string;
    DISPLAY_NAME: string;
    LOCATION_TYPE: LocationType;
    OTHER_TYPE: string;
    ADDRESS: string;
    ZIP: Zip;
    STATE: string;
    CITY: string;
    IS_OWNED: boolean;
    IS_OWNED_ON_BS: boolean;
    IS_RENT_INCREASE: boolean;

    // For Rent
    MARKET_RENT: number;
    RENT_EXPENSE: number;
    RENT_EXPENSE_EACH_YEAR: boolean;
    RENT_ADJUSTMENT_YEARLY: Array<LocationRentAdjustment>;
    AUTO_CALCULATED: boolean;
    RENT_CALCULATION_TYPE: RentCalculationTypes;
    SQUARE_FOOTAGE: number;
    FAIR_MARKET_SQFT: number;
    APPROXIMATE_VALUE: number;
    FULL_OCCUPATION: boolean;
    PERCENT_OCCUPATION: number;
    NEGOTIATED_RENT: number;

    ORDER: string;

    // helper
    isSqfVisivle: boolean = false;

    static parse(json: any): Location {
        if (json) {
            const l = new Location();

            l.ID = json.ID;
            l.IS_PRIMARY = json.IS_PRIMARY;
            l.NAME = json.NAME;
            l.DISPLAY_NAME = json.DISPLAY_NAME;

            l.LOCATION_TYPE = LocationType[<string>json.LOCATION_TYPE];

            l.OTHER_TYPE = json.OTHER_TYPE;
            l.ADDRESS = json.ADDRESS;

            if (json.ZIP)
                l.ZIP = Zip.parse(json.ZIP);

            l.STATE = json.STATE;
            l.CITY = json.CITY;
            l.IS_OWNED = json.IS_OWNED;
            l.IS_OWNED_ON_BS = json.IS_OWNED_ON_BS;
            l.IS_RENT_INCREASE = json.IS_RENT_INCREASE;
            l.MARKET_RENT = json.MARKET_RENT;

            // Rent
            l.RENT_EXPENSE = json.RENT_EXPENSE;
            l.RENT_EXPENSE_EACH_YEAR = json.RENT_EXPENSE_EACH_YEAR;

            if (json.RENT_ADJUSTMENT_YEARLY)
                l.RENT_ADJUSTMENT_YEARLY = LocationRentAdjustment.parseArray(json.RENT_ADJUSTMENT_YEARLY);
            
            l.AUTO_CALCULATED = json.AUTO_CALCULATED;
            l.RENT_CALCULATION_TYPE = RentCalculationTypes[<string>json.RENT_CALCULATION_TYPE];
            l.SQUARE_FOOTAGE = json.SQUARE_FOOTAGE;
            l.FAIR_MARKET_SQFT = json.FAIR_MARKET_SQFT;
            l.APPROXIMATE_VALUE = json.APPROXIMATE_VALUE;
            l.FULL_OCCUPATION = json.FULL_OCCUPATION;
            l.PERCENT_OCCUPATION = json.PERCENT_OCCUPATION;
            l.NEGOTIATED_RENT = json.NEGOTIATED_RENT;

            l.ORDER = json.ORDER;

            return l;
        } else return null;
    }

    static parseArray(json: Array<any>): Array<Location> {
        const arr = [];

        if (json)
            for (const j of json)
                if (j)
                    arr.push(Location.parse(j));

        return arr;
    }

}
